/* eslint-disable no-plusplus */
import { useState, useEffect } from 'react';

// mui imports
import { CircularProgress, Grid } from '@mui/material';

// project-imports
import { dispatch, useSelector } from 'store';
import { getAcquisitionChannel, getDestinationData, getProductSoldData, getOrganizationDetails } from 'store/slices/memberDetails';
import { getBusinessDocuments } from 'store/slices/memberPriority';
import EditOrganizationDetails from './editOrganizationDetails';
import BusinessDocuments from './businessDocuments';
import KycDetails from './kycDetails';

// third-party
import PropTypes from 'prop-types';
import { refreshElasticData } from 'store/slices/refreshElastic';

const OrganizationDetails = ({ organizationCode }) => {
    const memberDetailsData = useSelector((state) => state?.memberDetails);
    const { isOrgDetailsLoading = false } = memberDetailsData || {};

    const [incorporationYearsData, setIncorporationYearsData] = useState([]);

    const getYearData = () => {
        const startYear = 1950;
        const currentYear = new Date().getFullYear();
        const yearArray = [];
        for (let i = currentYear; i >= startYear; i--) {
            const yearObj = {};
            yearObj.label = String(i);
            yearObj.value = String(i);
            yearObj.id = i;
            yearArray.push(yearObj);
        }
        setIncorporationYearsData(yearArray);
    };

    useEffect(() => {
        getYearData();
        dispatch(getProductSoldData());
        dispatch(getAcquisitionChannel());
        dispatch(getDestinationData());
    }, []);

    useEffect(() => {
        if (!organizationCode) return;
        dispatch(getOrganizationDetails(organizationCode));
        dispatch(getBusinessDocuments(organizationCode));
        dispatch(refreshElasticData('', 'organization', organizationCode));
    }, [organizationCode]);

    return (
        <>
            {isOrgDetailsLoading ? (
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                </Grid>
            ) : (
                <Grid container item xs={12} spacing={3}>
                    <Grid item xs={12}>
                        <EditOrganizationDetails organizationCode={organizationCode} incorporationYearsData={incorporationYearsData} />
                    </Grid>
                    <Grid item xs={12}>
                        <KycDetails />
                    </Grid>
                    <Grid item xs={12}>
                        <BusinessDocuments organizationCode={organizationCode} />
                    </Grid>
                </Grid>
            )}
        </>
    );
};

OrganizationDetails.propTypes = {
    organizationCode: PropTypes.string
};

export default OrganizationDetails;
